// Column definitions for analytics and channel tables
export const PLATFORM_COLUMNS = [
  {
    id: "platform",
    label: "Platform",
    sortable: true,
  },
  {
    id: "total_apps",
    label: "Total Prod App Instances",
    sortable: true,
  },
  {
    id: "red_channel",
    label: "Red Channel",
    sortable: true,
  },
  {
    id: "green_channel",
    label: "Green Channel",
    sortable: true,
  },
  {
    id: "red_percentage",
    label: "Red %",
    sortable: true,
  },
];

export const PORTFOLIO_COLUMNS = [
  {
    id: "portfolio",
    label: "Portfolio",
    sortable: true,
  },
  {
    id: "total_apps",
    label: "Total Prod App Instances",
    sortable: true,
  },
  {
    id: "red_channel",
    label: "Red Channel",
    sortable: true,
  },
  {
    id: "green_channel",
    label: "Green Channel",
    sortable: true,
  },
  {
    id: "red_percentage",
    label: "Red %",
    sortable: true,
  },
];

export const getChannelTableColumns = (activeChannelTab) => {
  const baseColumns = [
    { id: "edit_action", label: "Actions", sortable: false },
    { id: "app_id", label: "App ID", sortable: true },
    { id: "app_name", label: "App Instance Name", sortable: true },
    { id: "platform", label: "Platform", sortable: true },
    { id: "portfolio", label: "Portfolio", sortable: true },
    { id: "trigger_type", label: "Trigger", sortable: true },
    { id: "latest_incident", label: "Latest Incident", sortable: true },
    { id: "priority", label: "Priority", sortable: true },
    { id: "latest_incident_date", label: "Latest Incident Date", sortable: true },
    { id: "added_to_red_channel", label: "Added to Red Channel", sortable: true },
    { id: "final_review", label: "Final Review", sortable: true },
    { id: "deployment_type", label: "Deployment Type", sortable: true },
    { id: "deployment_details", label: "Deployment Details", sortable: true },
  ];

  // Only show compliance columns in "Red Channel" tab
  if (activeChannelTab === "Red Channel") {
    baseColumns.splice(5, 0,
      { id: "change_management_compliance", label: "Change Management Compliance", sortable: true },
      { id: "days_since_added_to_red_channel", label: "Days Since Added to Red Channel", sortable: true }
    );
  }

  // Keep "Added to Red Channel" right after the new Red-only columns
  if (activeChannelTab === "Red Channel") {
    const addedToRedIndex = baseColumns.findIndex((column) => column.id === "added_to_red_channel");
    if (addedToRedIndex > -1) {
      const [addedToRedColumn] = baseColumns.splice(addedToRedIndex, 1);
      baseColumns.splice(7, 0, addedToRedColumn);
    }
  }

  // Only show status column in "All" tab
  if (activeChannelTab === "All") {
    baseColumns.splice(5, 0, {
      id: "status",
      label: "Status",
      sortable: true,
    });
  }

  if (activeChannelTab === "Moved to Green Channel" || activeChannelTab === "All") {
    const insertIndex = activeChannelTab === "All" ? 11 : 10;
    baseColumns.splice(insertIndex, 0, {
      id: "moved_to_green_channel_on",
      label: "Moved to Green Channel",
      sortable: true,
    });
  }

  return baseColumns;
};

export const CHANNEL_TAB_LABELS = ["Red Channel", "Moved to Green Channel", "All"];

export const RECORDS_PER_PAGE = 100;

export const TRIGGER_OPTIONS = [
  { value: "Major Incident", label: "Major Incident" },
  { value: "SLO Breach", label: "SLO Breach" },
  { value: "Search & Create a tag", label: "Search & Create a tag" },
];

export const STATUS_OPTIONS = [
  { value: "Red", label: "Red" },
  { value: "Green", label: "Green" },
];

export const DEPLOYMENT_OPTIONS = [
  { value: "Manual", label: "Manual" },
  { value: "Automated", label: "Automated" },
];
